/* eslint-disable no-self-assign */
import smsTemplate from '@/api/smsTemplate'
import get from 'lodash/get'

const INITIAL_STATE = {
  smsTemplateList: {},
  smsTemplateLabels: [],
}

export default {
  namespace: 'smsTemplate',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setSmsTemplateList(state, { payload }) {
      return { ...state, smsTemplateList: payload }
    },
    setSmsTemplateLabels(state, { payload }) {
      return { ...state, smsTemplateLabels: payload }
    },
  },

  effects: {
    *createSmsTemplate({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(smsTemplate.createSmsTemplate, {
        data: {
          ...payload,
          createdBy: get(account, 'accountId'),
          accountId: get(account, 'accountId'),
        },
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }

      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *editSmsTemplate({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(smsTemplate.editSmsTemplate, {
        data: {
          ...payload,
          createdBy: get(account, 'accountId'),
          accountId: get(account, 'accountId'),
        },
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *getSmsTemplates({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(smsTemplate.getSmsTemplates, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'smsTemplate/setSmsTemplateList', payload: resData })
        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getSmsTemplateHtml({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(smsTemplate.getSmsTemplateHtml, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let error = true

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined

          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.()
      }
    },

    *getSmsTemplateHisHtml({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(smsTemplate.getSmsTemplateHisHtml, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let error = true

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined

          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.()
      }
    },

    *getSmsTemplateLabels({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(smsTemplate.getSmsTemplateLabels, {
        params: { accountId: get(account, 'accountId'), ...payload },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'smsTemplate/setSmsTemplateLabels', payload: resData })

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getSmsTemplateAddableLabels({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const { smsTempId, ...restPayload } = payload
      const response = yield call(smsTemplate.getSmsTemplateAddableLabels, {
        smsTempId,
        params: { accountId: get(account, 'accountId'), ...restPayload },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getSmsTemplateById({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(smsTemplate.getSmsTemplateById, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let error = true

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined

          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.()
      }
    },

    *getSmsTemplateHisById({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(smsTemplate.getSmsTemplateHisById, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let error = true

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined

          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.()
      }
    },

    *deleteSmsTemplate({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(smsTemplate.deleteSmsTemplate, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *deleteSmsTemplateLabel({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(smsTemplate.deleteSmsTemplateLabel, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },
  },
}
